export default __webpack_public_path__ + "static/media/02.8883b214.png";